import { render } from "./AppModalReview.vue?vue&type=template&id=081cefd6&scoped=true"
import script from "./AppModalReview.vue?vue&type=script&lang=js"
export * from "./AppModalReview.vue?vue&type=script&lang=js"

import "./AppModalReview.vue?vue&type=style&index=0&id=081cefd6&scoped=true&lang=css"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081cefd6"]])

export default __exports__